export default "__VITE_ASSET__BmacpkNt__"